// withUploadToken — يُلحق رمز الدخول كـ ?token= بروابط /uploads (معالجة C2).
// السبب: الخادم يحمي /uploads الآن، ووسوم <img>/<a> عبر أصل مختلف لا تُرسل
// ترويسة Authorization، فنمرّر الرمز عبر الاستعلام بدلًا منها.
export function withUploadToken(url) {
  if (!url) return url;
  const token =
    localStorage.getItem('token') || localStorage.getItem('access_token');
  if (!token) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}token=${encodeURIComponent(token)}`;
}

export default withUploadToken;
